export var PageType;
(function (PageType) {
    PageType[PageType["SEARCH_RESULTS"] = 102] = "SEARCH_RESULTS";
    PageType[PageType["CATEGORY"] = 104] = "CATEGORY";
    PageType[PageType["ARTICLE"] = 210] = "ARTICLE";
    PageType[PageType["HOME_PAGE"] = 240] = "HOME_PAGE";
    PageType[PageType["CONTACT_PAGE"] = 250] = "CONTACT_PAGE";
})(PageType || (PageType = {}));
export var defaultPlaceholderKeys = {
    COMPANY_NAME: 'COMPANY_NAME',
    COMPANY_LOGO: 'COMPANY_LOGO',
    CANONICAL_URL: 'CANONICAL_URL'
};
export var pagePlaceholderKeys = {
    SEARCH: {
        SEARCH_TERM: 'SEARCH_TERM'
    },
    ARTICLE: {
        ARTICLE_TITLE: 'ARTICLE_TITLE',
        ARTICLE_PREVIEW: 'ARTICLE_PREVIEW',
        CATEGORY_TITLE: 'CATEGORY_TITLE',
        PARENT_CATEGORY_TITLE: 'PARENT_CATEGORY_TITLE'
    },
    CATEGORY: {
        CATEGORY_TITLE: 'CATEGORY_TITLE',
        PARENT_CATEGORY_TITLE: 'PARENT_CATEGORY_TITLE'
    }
};
//# sourceMappingURL=page-type.enum.js.map